module.exports = __webpack_public_path__ + "img/in.6fde196c.svg";